import { mergeStyles } from "@fluentui/merge-styles";

export const listStyle = mergeStyles({
  listStyle: "none",
  padding: 0,
  margin: 0,
});

export const listItemStyle = mergeStyles({
  display: "flex",
  alignItems: "center",
  padding: "8px",
  borderBottom: "1px solid #ccc",
});

export const labelStyle = mergeStyles({
  fontSize: "14px",
  fontWeight: "bold",
  marginRight: "8px",
});
